export const QUICK_FILL_SEND_MESSAGE_LIMIT = 50;
